//FullContentDetailsThreejs

import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import CustomDivider from '../../shared/utils/CustomDivider';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid2,
  IconButton,
  Icon,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid_Gap, ImagePathNode } from '../../shared/constants';
import { useGetLmsBasicDetailThreejs, useGetLmsSubtopicDetailThreejs, useGetLmsSubtopicThreejs, useGetLmsTopicThreejs } from '../../assets/api/useAdminApi';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';







const FullContentDetailsThreejs = () => {
  const navigate = useNavigate()
  const { id } = useParams();
  console.log(useParams(), 'courseId from params');
  const [courseId, setCourseId] = useState(id);
  const [voiceGender, setVoiceGender] = useState("male");
  
  // const { data: lmsBasicDetail, isLoading: isLmsBasicDetailLoading } = useGetLmsBasicDetailThreejs(id)
  // const { data: lmsBasicDetail, isLoading: isLmsBasicDetailLoading } = useGetLmsBasicDetailThreejs(courseId);

  const {
    data: lmsBasicDetail,
    isLoading: isLmsBasicDetailLoading,
  } = useGetLmsBasicDetailThreejs(courseId, {
    enabled: !!courseId,
  });

  const [expandedTopic, setExpandedTopic] = useState(null);
  const [expandedSubtopic, setExpandedSubtopic] = useState(null);
  const [expandedParagraph, setExpandedParagraph] = useState(null);
  const [selectedTopic, setSelectedTopic] = useState(null);
  // ---------- TOPIC PAGINATION ----------
  const {
    data: topicData,
    fetchNextPage: fetchNextTopicPage,
    hasNextPage: hasNextTopicPage,
    isFetchingNextPage: isFetchingNextTopicPage,
    isLoading: islmsTopicLoading,
    refetch: refetchTopics,
  } = useGetLmsTopicThreejs(courseId)

  console.log(topicData,'topicData')

  useEffect(() => {
    refetchTopics();
  }, []);

  const loadMoreTopicRef = useRef();

  useEffect(() => {
    const current = loadMoreTopicRef.current;

    if (!current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasNextTopicPage) {
          fetchNextTopicPage();
        }
      },
      { rootMargin: "100px" }
    );

    observer.observe(current);

    return () => {
      observer.unobserve(current);
    };
  }, [hasNextTopicPage, topicData]);



  // ---------- SUBTOPIC PAGINATION (BASED ON SELECTED TOPIC) ----------
  const {
    data: subtopicData,
    fetchNextPage: fetchNextSubtopicPage,
    hasNextPage: hasNextSubtopicPage,
    isFetchingNextPage: isFetchingNextSubtopicPage,
    isLoading: islmsSubTopicLoading,
  } = useGetLmsSubtopicThreejs(expandedTopic);






  const loadMoreSubTopicRef = useRef();

  useEffect(() => {
    const current = loadMoreSubTopicRef.current;

    if (!current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasNextSubtopicPage) {
          fetchNextSubtopicPage();
        }
      },
      { rootMargin: "100px" }
    );

    observer.observe(current);

    return () => {
      observer.unobserve(current);
    };
  }, [hasNextSubtopicPage, subtopicData]);



  const handleTopicChange = (topicId) => {
    setExpandedTopic(expandedTopic === topicId ? null : topicId);
    setExpandedSubtopic(null)
    setExpandedParagraph(null)
  };

  const { data: subTopicDetail, isLoading: subTopicLoading } = useGetLmsSubtopicDetailThreejs(expandedSubtopic)

  const handleSubtopicChange = (subtopicId) => {
    setExpandedSubtopic(expandedSubtopic === subtopicId ? null : subtopicId);
    setExpandedParagraph(null)

  };

  const handleParagraphChange = (paragraphId) => {
    setExpandedParagraph(expandedParagraph === paragraphId ? null : paragraphId);
  };
  const courseDetail = {
    "Course Type": lmsBasicDetail?.mapping?.course_type,
    Grade: lmsBasicDetail?.mapping?.grade?.name,
    Board: lmsBasicDetail?.mapping?.board?.name,
    Language: lmsBasicDetail?.mapping?.language?.name,
    Publication: lmsBasicDetail?.mapping?.publication?.name,
    Level: lmsBasicDetail?.mapping?.level?.name

  }




  return (
    <NormalContainerWithHeader headerText={lmsBasicDetail?.courseName}>
      {isLmsBasicDetailLoading && (
        <Box sx={{ padding: "1rem" }}>
          {[...Array(5)].map((_, index) => (
            <Box key={index}>
              <SkeletonCom height={50} style={{ borderRadius: "5px" }} />
              <CustomDivider size={"1rem"} />
            </Box>
          ))}
        </Box>
      )}



      <>

        {
          !isLmsBasicDetailLoading &&
          <Grid2 container spacing={Grid_Gap}>

            {Object.entries(courseDetail).map(([key, value], index) => (
              <Grid2 children size={6}>
                <Typography variant="body2" fontWeight={600}>
                  {key} : {value}
                </Typography>
              </Grid2>

            ))}

          </Grid2>
        }

        <CustomDivider />

        {
          !islmsTopicLoading &&
          <>
            {topicData?.pages.map((page, topicPageIndex) =>
              page.topics.map((topic, topicIndex) => (
                <Box key={topic.id} sx={{ mb: 3 }}>
                  <Accordion
                    expanded={expandedTopic === topic.id}
                    onChange={() => handleTopicChange(topic.id)}
                    sx={styles.accordionTopic}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="body1" fontWeight={600}>
                        Topic {topicPageIndex * 10 + (topicIndex + 1)} : {topic.name}
                      </Typography>
                    </AccordionSummary>

                    <AccordionDetails>

                      {expandedTopic === topic.id && (
                        <>
                          {
                            islmsSubTopicLoading && <Typography>subtopic is loading...... </Typography>
                          }

                          {
                            !islmsSubTopicLoading && (
                              <>
                                {subtopicData?.pages.map((page, pageIndex) =>
                                  page.subtopics.map((subtopic, index) => (
                                    <Accordion
                                      key={subtopic.id}
                                      sx={styles.accordionSubtopic}
                                      expanded={expandedSubtopic === subtopic.id}
                                      onChange={() => handleSubtopicChange(subtopic.id)}
                                    >
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                      >
                                        <Box
                                          sx={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            fontWeight={600}
                                          >
                                            Script{" "}
                                            {pageIndex * 10 + (index + 1)} :
                                            {" "}
                                            {subtopic.name}
                                          </Typography>

                                          <IconButton
                                            onClick={(e) => {
                                              e.stopPropagation();

                                              navigate(
                                                `/admin/addeditsubtopicthree/${topic?.id}/${subtopic.id}`
                                              );
                                            }}
                                          >
                                            <EditIcon />
                                          </IconButton>
                                        </Box>
                                      </AccordionSummary>

                                      <AccordionDetails>
                                        {expandedSubtopic === subtopic.id && (
                                          <>
                                            {subTopicLoading ? (
                                              <Typography>
                                                Loading subtopic detail...
                                              </Typography>
                                            ) : (
                                              <>
                                                {/* QUESTIONS */}

                                                {subTopicDetail?.data
                                                  ?.question_voices && (

                                                    <Box mt={2}>

                                                      {/* VOICE SELECT */}

                                                      <FormControl>
                                                        <RadioGroup
                                                          row
                                                          value={voiceGender}
                                                          onChange={(e) =>
                                                            setVoiceGender(e.target.value)
                                                          }
                                                        >
                                                          <FormControlLabel
                                                            value="male"
                                                            control={
                                                              <Radio
                                                                sx={{
                                                                  color: "blue.main",
                                                                  "&.Mui-checked": {
                                                                    color: "blue.main",
                                                                  },
                                                                }}
                                                              />
                                                            }
                                                            label="Male"
                                                          />

                                                          <FormControlLabel
                                                            value="female"
                                                            control={
                                                              <Radio
                                                                sx={{
                                                                  color: "blue.main",
                                                                  "&.Mui-checked": {
                                                                    color: "blue.main",
                                                                  },
                                                                }}
                                                              />
                                                            }
                                                            label="Female"
                                                          />
                                                        </RadioGroup>
                                                      </FormControl>

                                                      {/* QUESTION */}

                                                      <Box
                                                        sx={{
                                                          backgroundColor:
                                                            "primary.light",
                                                          padding: 2,
                                                          borderRadius: 2,
                                                          border:
                                                            "1px solid #E5E7EB",
                                                          mt: 1,
                                                        }}
                                                      >
                                                        <Typography
                                                          fontWeight={600}
                                                          display="flex"
                                                          alignItems="center"
                                                          justifyContent="space-between"
                                                        >
                                                          <span>
                                                            Q1.{" "}

                                                            {
                                                              subTopicDetail
                                                                ?.data
                                                                ?.question_voices?.[
                                                                voiceGender
                                                              ]?.question_text
                                                            }
                                                          </span>

                                                          <VolumeUpIcon
                                                            sx={{
                                                              fontSize: 18,
                                                              cursor:
                                                                "pointer",
                                                              color: "blue.main",

                                                            }}
                                                            onClick={() => {

                                                              const voice =
                                                                subTopicDetail
                                                                  ?.data
                                                                  ?.question_voices?.[
                                                                voiceGender
                                                                ];

                                                              if (
                                                                voice?.voice_url
                                                              ) {

                                                                const audio =
                                                                  new Audio(
                                                                    `${ImagePathNode}${voice.voice_url}`
                                                                  );

                                                                audio.play();
                                                              }
                                                            }}
                                                          />
                                                        </Typography>
                                                      </Box>

                                                      {/* ANSWERS */}

                                                      <Box
                                                        sx={{
                                                          backgroundColor:
                                                            "primary.light",
                                                          padding: 2,
                                                          borderRadius: 2,
                                                          border:
                                                            "1px solid #E5E7EB",
                                                          mt: 1,
                                                        }}
                                                      >
                                                        <Typography
                                                          sx={{
                                                            mb: 1,
                                                            color: "#666",
                                                          }}
                                                        >
                                                          Added answers for the
                                                          question
                                                        </Typography>

                                                        {subTopicDetail?.data
                                                          ?.answers?.length >
                                                          0 ? (

                                                          subTopicDetail?.data?.answers.map(
                                                            (
                                                              answer,
                                                              aIndex
                                                            ) => (

                                                              <Typography
                                                                key={answer.id}
                                                                sx={{
                                                                  ml: 2,
                                                                  mb: 1,
                                                                }}
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="space-between"
                                                              >
                                                                <span>
                                                                  {aIndex + 1}.{" "}

                                                                  {
                                                                    answer.question_text
                                                                  }
                                                                </span>

                                                                <VolumeUpIcon
                                                                  sx={{
                                                                    fontSize: 18,
                                                                    cursor:
                                                                      "pointer",
                                                                    color:
                                                                      "blue.main",
                                                                  }}
                                                                  onClick={() => {

                                                                    if (
                                                                      answer?.voice_url
                                                                    ) {

                                                                      const audio =
                                                                        new Audio(
                                                                          `${ImagePathNode}${answer.voice_url}`
                                                                        );

                                                                      audio.play();
                                                                    }
                                                                  }}
                                                                />
                                                              </Typography>
                                                            )
                                                          )
                                                        ) : (
                                                          <Typography>
                                                            No Answers
                                                            Available
                                                          </Typography>
                                                        )}
                                                      </Box>
                                                    </Box>
                                                  )}
                                              </>
                                            )}
                                          </>
                                        )}
                                      </AccordionDetails>
                                    </Accordion>
                                  ))
                                )}

                                {/* ADD SCRIPT */}

                                <IconButton
                                  onClick={() => {
                                    navigate(
                                      `/admin/addeditsubtopicthree/${topic.id}`,
                                      {
                                        state: {
                                          topic,
                                          index: topicIndex,
                                        },
                                      }
                                    );
                                  }}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <AddIcon />

                                  <Typography>
                                    Add Script
                                  </Typography>
                                </IconButton>

                                {isFetchingNextSubtopicPage && (
                                  <p>Loading more subtopics...</p>
                                )}

                                <div
                                  ref={loadMoreSubTopicRef}
                                  style={{
                                    height: "20px",
                                    marginTop: "10px",
                                  }}
                                />
                              </>
                            )
                          }

                        </>
                      )}


                    </AccordionDetails>
                  </Accordion>
                </Box>
              ))
            )}
            <>

              <IconButton
                onClick={() => { navigate(`/admin/addquestionThreejs/${courseId}`) }}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <AddIcon /> <Typography>Add Topic</Typography>

              </IconButton>


            </>


            {isFetchingNextTopicPage && <p>Loading more topics...</p>}

            <div
              ref={loadMoreTopicRef}
              style={{ height: "20px", marginTop: "10px" }}
            />
          </>
        }
      </>

    </NormalContainerWithHeader>

  );

};

// ===== STYLES =====
const styles = {
  accordionTopic: {
    border: "1px solid #4169E1",
    borderRadius: 5,
    boxShadow: 'none',
    mb: 1
  },
  accordionSubtopic: {
    // border: "1px solid #4169E1",
    backgroundColor: '#F7FAFF',
    borderRadius: 3,
    boxShadow: 'none',
    mb: 1
  },
  accordionParagraph: {
    // border: "1px solid #4169E1",
    backgroundColor: '#ffffff',
    borderRadius: 2,
    boxShadow: 'none',
    mb: 1
  },
  accordionParagraph1: {
    // border: "1px solid #4169E1",
    backgroundColor: '#F9F9F9',
    borderRadius: 2,
    boxShadow: 'none',
    mb: 1
  },
  qaContainer: {
    mt: 1,
    pl: 2,
  },
  questionBox: {
    mb: 1,
  },
  questionText: {
    fontWeight: 600,
    color: '#333',
  },
  answerText: {
    ml: 2,
    color: '#555',
  }
};

export default FullContentDetailsThreejs;






































